export default "/Frontend/dist/event-background2.9d252e312baaa510efdf5013d36edac1.svg";